/** 退款操作类型 用于判断是否支持异步操作的 */
export enum ActionType {
    /** 仅退款 */
    REFUND = '仅退款',
    /** 同意买家退货 */
    AGREE_RETURN = '同意买家退货',
    /** 退货退款 */
    RETURN_REFUND = '退货退款',
}

/** 用于 退款操作类型匹配对应按钮操作是否支持 */
export enum ActionTypeV2 {
    /** 仅退款 */
    REFUND = '同意仅退款',
    /** 同意买家退货 */
    AGREE_RETURN = '同意买家退货',
    /** 退货退款 */
    RETURN_REFUND = '买家已退货，同意退款',
}

/** 支持异步处理退款的操作类型（这里兼容一下两种类型的type,因为在判断是否支持退款、退货操作按钮时候用的ActionTypeV2，里面也会用到这里） */
export const SUPPORTED_ACTION_TYPES = [
    ActionType.REFUND,
    ActionType.RETURN_REFUND,
    ActionType.AGREE_RETURN,
    ActionTypeV2.REFUND,
    ActionTypeV2.RETURN_REFUND,
    ActionTypeV2.AGREE_RETURN,
] as const
